<h2 mat-dialog-title>Certificate Status</h2>
<mat-dialog-content>
    <p role="status" aria-live="polite" aria-atomic="true" tabindex="-1" cdkFocusInitial>
        {{ currentStatus }}
    </p>
</mat-dialog-content>
